module.exports = __webpack_public_path__ + "static/media/logout.bdd56291.svg";